import { createTooltipItems } from "../tooltips/highchartTooltip";
import { formatPointLabel } from "components/widgets/chart/base/utils";
import { getLeafValue } from "hooks/widget-data/datapoints-api/helper";
import { ChartSelectValueFormatKind } from "store/current-dashboard/types";
const getChartData = (columns, data, dimension) => {
    const result = columns.map((col) => {
        const colData = data[col.aggregate];
        const y = getLeafValue(colData);
        const formatted = col.formatted ? data[col.formatted] : formatPointLabel(y, ChartSelectValueFormatKind.percent);
        return { ...col,
            custom: { formatted, tooltip: createTooltipItems([{ label: col.title, value: formatted }]) },
            name: dimension ?? col.title,
            value: y,
            y };
    });
    return result?.filter((i) => i !== null);
};
const getFormat = (data) => {
    for (const measure of data) {
        if (measure.additionalData?.format) {
            return measure.additionalData.format;
        }
        if (measure.data) {
            return getFormat(measure.data);
        }
    }
    return undefined;
};
export const highchartsMultipleMeasures = (params) => (args) => {
    if (!args.context.staticData.customResult?.length) {
        args.context.staticData.customResult = [];
    }
    const visitable = args.visitable;
    const data = visitable?.data?.[0]?.measures;
    if (data) {
        args.context.staticData.customResult = [{ series: getChartData(params, data) }];
    }
    return [];
};
export const highchartsMultipleMeasuresSideBySide = (params) => (args) => {
    if (!args.context.staticData.customResult?.length) {
        args.context.staticData.customResult = [];
    }
    const visitable = args.visitable;
    const charData = visitable?.data?.filter((x) => x.measures).map((x) => getChartData(params, x.measures ?? {}, x.dimension?.toString()));
    if (charData) {
        const series = charData[0].map((x) => ({ series: [x] }));
        charData.forEach((x, i) => {
            if (i > 0) {
                x.map((y, j) => series[j].series.push(y));
            }
        });
        args.context.staticData.customResult = series;
        if (!visitable.additionalData) {
            visitable.additionalData = {};
        }
        if (visitable.data) {
            visitable.additionalData.format = getFormat(visitable.data);
        }
    }
    return [];
};
